package org.example.project.client.model

import kotlinx.serialization.Serializable

@Serializable
enum class BlockType {
    CATALOG_GAME,
    CUSTOM_GAME,
    OTHER;

    companion object {
        fun fromString(value: String): BlockType {
            return entries.firstOrNull { it.name.equals(value.trim(), ignoreCase = true) }
                ?: throw IllegalArgumentException("Unknown block type: '$value'")
        }
    }
}

@Serializable
data class EventBlockResponse(
    val id: String,
    val eventId: String,
    val blockType: BlockType,
    val title: String,
    val startTime: String,
    val endTime: String,
    val instructions: String? = null,
    val description: String? = null,
    val notes: String? = null,
    val activityId: String? = null,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class EventResponse(
    val id: String,
    val ownerId: String,
    val name: String,
    val date: String? = null,
    val startTime: String,
    val endTime: String,
    val version: Long,
    val createdAt: String,
    val updatedAt: String,
    val blocks: List<EventBlockResponse> = emptyList()
)

@Serializable
data class FavoritesResponse(
    val activityIds: List<String>,
    val items: List<ActivityResponse> = emptyList()
)

@Serializable
data class CreateEventBlockRequest(
    val id: String? = null,
    val blockType: BlockType,
    val title: String,
    val startTime: String,
    val endTime: String,
    val instructions: String? = null,
    val description: String? = null,
    val notes: String? = null,
    val activityId: String? = null
)

@Serializable
data class CreateEventRequest(
    val id: String? = null,
    val name: String,
    val date: String? = null,
    val startTime: String,
    val endTime: String,
    val blocks: List<CreateEventBlockRequest>? = null
)

@Serializable
data class UpdateEventBlockRequest(
    val id: String? = null,
    val blockType: BlockType,
    val title: String,
    val startTime: String,
    val endTime: String,
    val instructions: String? = null,
    val description: String? = null,
    val notes: String? = null,
    val activityId: String? = null
)

@Serializable
data class UpdateEventRequest(
    val expectedVersion: Long,
    val name: String,
    val date: String? = null,
    val startTime: String,
    val endTime: String,
    val blocks: List<UpdateEventBlockRequest>? = null
)
